import { extend } from 'umi-request';
import { history } from '@umijs/max';
import { message } from 'antd';

// 创建请求实例
const request = extend({
  prefix: '/basic-api',
  timeout: 60 * 1000,
  credentials: 'include',
});

// 请求拦截器 - 添加 token 和防缓存处理
request.interceptors.request.use((url, options) => {
  const token = localStorage.getItem('token');

  // 添加防缓存头部
  const headers = {
    ...(options.headers || {}),
    // 'Cache-Control': 'no-cache, no-store, must-revalidate',
    // 'Pragma': 'no-cache',
    // 'Expires': '0',
  };

  if (token) {
    (headers as any).Authorization = `Bearer ${token}`;
  }

  // 为GET请求添加时间戳参数防止缓存
  let finalUrl = url;
  if (!options.method || options.method.toLowerCase() === 'get') {
    const separator = url.includes('?') ? '&' : '?';
    finalUrl = `${url}${separator}_t=${Date.now()}`;
  }

  return {
    url: finalUrl,
    options: {
      ...options,
      headers,
    },
  };
});

// 响应拦截器 - 处理 token 过期
request.interceptors.response.use(async (response, _options) => {
  const data =  response.ok ? await response.clone().json() : null;
  console.log('request response', response.status, data);

  // 处理 token 过期或无效
  if (response.status === 401 || (data && data.status === 401)) {
    // 清除本地存储的用户数据
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('permissions');
    localStorage.removeItem('menus');

    message.error('登录已过期，请重新登录');

    // 跳转到登录页
    const currentPath = history.location.pathname;
    if (currentPath !== '/user/login') {
      history.replace('/user/login');
    }

    return Promise.reject(new Error('登录已过期'));
  }

  // 处理其他错误状态
  if (!response.ok) {
    const errorMessage = '请求出错，请稍候重试';
    message.error(errorMessage);
    return Promise.reject(new Error(errorMessage));
  }

  if (data && data.status !== 200) {
    let errorMessage = '请求出错，请稍候重试';
    if (data.status === 400 || data.status === 500) {
      errorMessage = data.message || errorMessage;
      message.error(errorMessage);
    }
    return Promise.reject(data);
  }

  // 返回解析后的数据，而不是response对象
  return data;
});

export default request;
